module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-pedal-tours-in-tuscaloosa-alabama-e99b469ca2120946534e7c26b0a9b055.png";